var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChartInactive = function SvgChartInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A8A8A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.584 20.167h16.5M5.967 7.682H4.5a.92.92 0 0 0-.917.916V16.5a.92.92 0 0 0 .917.917h1.467a.92.92 0 0 0 .916-.917V8.598a.92.92 0 0 0-.916-.916M12.567 4.757H11.1a.92.92 0 0 0-.916.917v10.825a.92.92 0 0 0 .916.917h1.467a.92.92 0 0 0 .917-.917V5.674a.92.92 0 0 0-.917-.917M19.167 1.833H17.7a.92.92 0 0 0-.916.917V16.5a.92.92 0 0 0 .916.916h1.467a.92.92 0 0 0 .917-.916V2.75a.92.92 0 0 0-.917-.917"
  })));
};
export default SvgChartInactive;